module.exports = __webpack_public_path__ + "img/usericon.13ea390f.svg";